import { render, staticRenderFns } from "./naklodnoyNew.vue?vue&type=template&id=1162e0a0&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./naklodnoyNew.vue?vue&type=script&lang=js"
export * from "./naklodnoyNew.vue?vue&type=script&lang=js"
import style0 from "./naklodnoyNew.vue?vue&type=style&index=0&id=1162e0a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162e0a0",
  null
  
)

export default component.exports